// View Keys
export default {
  alertsTabView_Profiles: "Profiles",
  alertsTabView_Alert: "Alerts",
  inboxTabView_Inbox: "Inbox",
  alersTabView_forGps:"For GPS devices",
  alersTabView_forCameras:"For Cameras"
};
